import './NotFound.scss'
function iframe() {
    return {
        __html: '<iframe src="./notfound.html" width = "100%" height = "100%" ></iframe>'
    }
}

export default function NotFound() {
    return <div className='not_found' data-testid="not_found" dangerouslySetInnerHTML={iframe()} />
}